<template>
  <div class="page">
    <div
      class="e-card card"
      :style="_style"
    >
      <div class="e-card-header">
        <!--
        <div class="e-card-header-caption" style="align-items: center">
-->
        <div class="e-card-header-caption">
          <div class="e-card-header-title">
            <h4>{{ title }}</h4>
          </div>
        </div>
      </div>
      <slot name="top" />
      <div class="e-card-content">
        <div :class="_contentClass">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {useDisplay} from "vuetify";

interface Props {
  title?: string;
  flexDirection?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
  flexDirection: "flex-row",
});

const {height} = useDisplay();
//const {menuSidebarVisible} = storeToRefs(useNavigationStore())

const _contentClass = computed(() =>
  props.flexDirection === "flex-row"
    ? "content content-flex-row"
    : "content content-flex-column"
);

const _style = computed(() => {
  //const t_marginLeft = menuSidebarVisible.value ? "margin-left: 5px;" : ""
  return (
    "min-height: " + (height.value - 100) + "px; justify-content: flex-start;"
  ); //+t_marginLeft
});
</script>

<style scoped>
.page {
  margin-top: 5px;
  min-height: 600px;
  /*
  min-height: -webkit-calc(100% - 300px);
  min-height: -moz-calc(100% - 300px);
  min-height: calc(100% - 300px);
  */
}

.card {
  margin-top: 5px;
}

.content-flex-row {
  flex-direction: row;
  align-items: flex-start;
}

.content-flex-column {
  flex-direction: column;
}

@media (max-width: 1025px) {
  .page {
    /*
    width: 99%;
    */
  }

  .content {
    flex-wrap: wrap;
    align-items: stretch;
    display: flex;
    justify-content: start;
    overflow-x: auto;
  }

  .e-card-header-caption {
    align-items: flex-start;
  }

  .e-card .e-card-content {
    padding: 0 6px 12px 6px;
  //background: red;
  }
}

@media (min-width: 1025px) {
  /* CSS */
  .page {
    /*
    width: 95%;
    */
  }

  .content {
    flex-wrap: wrap;
    align-items: stretch;
    display: flex;
    justify-content: center;
    overflow-x: auto;
  }

  .e-card-header-caption {
    align-items: center;
  }
}

.theme-dark .e-card:hover {
  background-color: #1f2937;
  border-color: #4b5563;
}

.theme-light .e-card:hover {
  background-color: white;
}

/*
.page .e-card .e-card-header{
.e-card > .e-card-header-title + :not(.e-card-header-title) {
*/
/*
padding-top: 0;
padding-bottom: 0;
*/

/*
}
justify-content: center;




}
row-gap: 1em;
column-gap: 1em;
*/

.break-word {
  word-wrap: break-word;
}
</style>
